<template>
    <v-container fill-height fluid grid-list-xl class="pt-0 px-3">
        <v-layout wrap>
            <v-flex xs12 class="pb-3">
                <v-card>
                    <v-card-actions class="pb-0">
                        <v-spacer></v-spacer>
                        <v-btn
                            class="text-xs-right"
                            color="success"
                            @click="submit"
                            >Submit</v-btn
                        >
                    </v-card-actions>
                    <v-layout column>
                        <v-card-actions class="pt-0">
                            <v-layout row>
                                <v-flex xs4 class="pt-0">
                                    <v-card-text class="pl-2"
                                        >Search By Name</v-card-text
                                    >
                                    <vue-select2
                                        style="font-size: 27px"
                                        class="mb-3 ml-2 select2-custom"
                                        :options="accounts"
                                        label="displayName"
                                        v-model="account"
                                        :filterable="false"
                                        @search="onSearchAccounts"
                                        @input="onSelected"
                                    ></vue-select2>
                                </v-flex>
                                <v-flex xs6 class="pt-0">
                                    <v-card-text class="pl-0"
                                        >Search By Phone Number</v-card-text
                                    >
                                    <v-layout row>
                                        <v-text-field
                                            solo
                                            label="Phone Number"
                                            v-model="phoneSearch"
                                            mask="###-###-####"
                                            @input="searchByPhone"
                                        ></v-text-field>
                                        <v-btn
                                            style="height: 48px;"
                                            class="ml-3"
                                            @click="searchDialog = true"
                                            >Search Accounts</v-btn
                                        >
                                        <v-btn
                                            style="height: 48px;"
                                            class="ml-3"
                                            color="info"
                                            @click="newAccountDialog = true"
                                            >New Account</v-btn
                                        >
                                        <v-btn
                                            v-if="account.nonUTA"
                                            style="height: 48px;"
                                            class="ml-3"
                                            color="info"
                                            @click="editAccount"
                                            >Edit Account</v-btn
                                        >
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                        <div v-if="account.accountID">
                            <v-flex xs12 class="pt-0">
                                <v-layout row>
                                    <v-layout column class="ml-4">
                                        <v-card-title
                                            primary-title
                                            class="pt-3 py-0"
                                        >
                                            <div>
                                                <v-layout
                                                    row
                                                    v-if="account.nonUTA"
                                                    align-center
                                                    class="pl-2 py-2"
                                                >
                                                    <h3 class="headline my-0">
                                                        Account ID:
                                                        {{ account.accountID }}
                                                    </h3>
                                                    <div
                                                        class="font-weight-medium ml-2 text-info"
                                                    >
                                                        Non UTA
                                                    </div>
                                                </v-layout>
                                                <h3
                                                    class="headline my-0"
                                                    v-if="!account.nonUTA"
                                                >
                                                    Account ID:
                                                    {{ account.accountID }}
                                                </h3>
                                            </div>
                                        </v-card-title>
                                        <v-card-text class="mb-2 py-0">
                                            <h4
                                                class="card-title font-weight-medium"
                                            >
                                                {{ account.name }}
                                            </h4>
                                            <p>
                                                {{ account.hname }}
                                            </p>
                                            <p>
                                                {{ account.address1 }}
                                            </p>
                                            <br />
                                            <div class="ml-2 mt-2">
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Home:
                                                    </div>
                                                    <div>
                                                        {{ account.homePhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Cell:
                                                    </div>
                                                    <div>
                                                        {{ account.cellPhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Email:
                                                    </div>
                                                    <div>
                                                        {{
                                                            account.emailAddress
                                                        }}
                                                    </div>
                                                </v-layout>
                                            </div>
                                        </v-card-text>
                                    </v-layout>
                                    <v-layout row wrap align-end fluid>
                                        <v-card-actions
                                            class="mr-5"
                                            style="width: 100%;"
                                        >
                                            <v-text-field
                                                style="width: 50%;"
                                                class="mr-3"
                                                label="Note"
                                                v-model="note"
                                            ></v-text-field>
                                            <v-select
                                                :items="
                                                    countries.map(
                                                        (c) => c.value,
                                                    )
                                                "
                                                ref="country"
                                                label="Country"
                                                v-model="country"
                                                :rules="countryRules"
                                                box
                                            >
                                            </v-select>
                                            <v-text-field
                                                ref="customCountry"
                                                class="ml-3"
                                                v-if="country == 'Other'"
                                                label="Country Name"
                                                v-model="customCountry"
                                                :rules="customCountryRules"
                                            ></v-text-field>
                                            <v-text-field
                                                v-bind:class="{
                                                    'bungalow-required': bungalowRequired(),
                                                }"
                                                ref="bungalow"
                                                class="ml-3 pt-0 pb-1"
                                                label="Bungalow"
                                                v-model="bungalow"
                                                hide-details
                                            ></v-text-field>
                                            <v-btn
                                                class="ml-3 mb-3"
                                                color="info"
                                                @click="newStudentDialog = true"
                                            >
                                                New Student
                                            </v-btn>
                                        </v-card-actions>
                                    </v-layout>
                                </v-layout>
                            </v-flex>
                        </div>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex xs8>
                <v-card v-if="loadingAccountInfo" class="pa-3">
                    <v-progress-linear
                        :indeterminate="true"
                        color="success"
                    ></v-progress-linear>
                </v-card>

                <v-card
                    class="mb-3"
                    v-if="!loadingAccountInfo && students.length"
                >
                    <v-card-title class="headline pr-0 pb-2 pt-3 pl-3"
                        >Lunch Document</v-card-title
                    >
                    <v-divider></v-divider>
                    <v-layout row justify-start align-start class="ml-3 pb-2">
                        <!-- <v-checkbox
                            label="Lunch Document"
                            v-model="lunchDocument"
                            color="success"
                            hide-details
                            class="mr-2"
                        ></v-checkbox>
                        <v-checkbox
                            label="Ineligible For Lunch Program"
                            v-model="lunchProgramIneligible"
                            color="success"
                            hide-details
                        ></v-checkbox> -->
                        <v-radio-group
                            v-model="lunchDocument"
                            row
                            hide-details
                            style="max-width: 450px;"
                        >
                            <v-radio
                                class="py-2 pr-2"
                                label="Lunch Document"
                                value="hasLunchDocument"
                                color="success"
                            ></v-radio>
                            <v-radio
                                class="py-2 pr-2"
                                label="Lunch Document Not Required"
                                value="lunchProgramIneligible"
                                color="success"
                            ></v-radio>
                        </v-radio-group>
                        <v-btn
                            small
                            outline
                            class="mr-2 ml-3 mb-2 mt-3"
                            :loading="uploading"
                            @click="pickFile()"
                        >
                            Upload Document
                            <v-icon right dark>mdi-cloud-upload</v-icon>
                        </v-btn>
                        <div v-if="files.length" class="mt-3 ml-2">
                            {{ files[0].name }}
                        </div>
                        <v-spacer></v-spacer>
                    </v-layout>
                    <input
                        type="file"
                        style="display: none"
                        ref="files"
                        accept="image/*,.pdf"
                        @change="onFilePicked($event)"
                    />
                    <div
                        v-if="
                            lunchDocument == 'hasLunchDocument' &&
                                !lunchDocumentUrl
                        "
                        class="ml-3 pb-3 text-danger"
                    >
                        Please upload the lunch document
                    </div>
                </v-card>
                <student-list
                    v-if="!loadingAccountInfo && students.length"
                    :students="students"
                    :classes="classes"
                    :girlsClasses="girlsClasses"
                    :account="account"
                    :gradesSetup="gradesSetup"
                    :dates="dates"
                    ref="studentsList"
                >
                </student-list>
            </v-flex>
            <v-flex xs4 class="pl-1">
                <balance-details
                    v-if="account.accountID"
                    :account="account"
                    :loading="loadingAccountInfo"
                    :regID="regID"
                    :pastYearsEnrollmentInfo="pastYearsEnrollmentInfo"
                    :reload="loadPastYearsEnrollmentInfo"
                ></balance-details>
            </v-flex>
        </v-layout>

        <v-dialog v-model="confirmDialog" max-width="500">
            <v-card>
                <v-card-title class="headline">Summary</v-card-title>

                <v-list two-line>
                    <template
                        v-for="(student, index) in students.filter(
                            (s) => s.duration != 'NONE',
                        )"
                    >
                        <v-list-tile avatar ripple>
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    student.engName
                                }}</v-list-tile-title>
                                <v-list-tile-sub-title
                                    >{{ getDurationDisplay(student) }}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-divider
                            v-if="
                                index + 1 <
                                    students.filter((s) => s.duration != 'NONE')
                                        .length
                            "
                        ></v-divider>
                    </template>
                </v-list>

                <v-card-actions class="text-xs-right pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        class="text-xs-right"
                        @click="confirmDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :disabled="processing"
                        class="text-xs-right"
                        color="success"
                        :loading="processing"
                        @click="confirm(false)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="searchDialog" max-width="1400">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="accounts"
                    :columns="accountsColumns"
                    :title="searchDialogTitle"
                    navigationPath="Account View"
                    navigationField="accountID"
                    v-bind:hideActions="true"
                    :onRowClicked="onSearchAccountsRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="newAccountDialog" max-width="800">
            <new-account
                ref="newAccount"
                :closeNewAccountModal="closeNewAccountModal"
                :onCreated="onNewAccountCreated"
            ></new-account>
        </v-dialog>
        <v-dialog persistent v-model="newStudentDialog" max-width="400">
            <new-student
                :onCreated="onNewStudentCreated"
                :closeNewStudentModal="closeNewStudentModal"
                :account="account"
                :gradesSetup="gradesSetup"
            ></new-student>
        </v-dialog>
    </v-container>
</template>
<script>
import vueSelect2 from "vue-select";
import { getDomain, sum, groupBy } from "../utils/helpers.js";
import odata from "odata-client";
import ky from "../utils/ky.js";
import studentsList from "./LapidusDayCamp/StudentList.vue";
import payment from "./LapidusDayCamp/Payment.vue";
import newAccount from "./LapidusDayCamp/newAccount.vue";
import newStudent from "./LapidusDayCamp/newStudent.vue";
import balanceDetails from "./LapidusDayCamp/BalanceDetails.vue";
import { loadOptions } from "../utils/smLookup.js";
import moment from "moment";

export default {
    components: {
        "vue-select2": vueSelect2,
        "student-list": studentsList,
        "new-account": newAccount,
        "new-student": newStudent,
        balanceDetails,
    },
    data: () => ({
        phoneSearch: "",
        accounts: [],
        countries: [],

        account: {},
        country: "",
        bungalow: "",
        customCountry: "",
        note: "",

        uploading: false,
        files: [],
        lunchDocument: false,
        lunchProgramIneligible: false,
        lunchDocumentUrl: "",
        loadingAccountInfo: false,

        students: [],
        cardHistory: [],
        rates: [],
        dates: [],

        gradesSetup: [],
        classes: [],
        girlsClasses: [],

        isGirls: false,

        confirmDialog: false,
        processing: false,

        countryRules: [(value) => !!value || "Required."],

        customCountryRules: [(value) => !!value || "Required."],

        searchDialogTitle: "Accounts",
        searchDialog: false,

        newAccountDialog: false,
        newStudentDialog: false,

        regID: "",
        pastYearsEnrollmentInfo: [],

        accountsColumns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                width: "200px",
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Name..",
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountID",
                width: "115px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Account ID..",
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                width: "250px",
                field: "hname",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: false,
                label: "Home Phone",
                field: "homePhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Home Phone..",
                },
            },
            {
                sortable: false,
                label: "Cellphone",
                field: "cellPhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Cellphone..",
                },
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                width: "200px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: false,
                label: "Email",
                field: "emailAddress",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Father",
                field: "father",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Shver",
                field: "shver",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    async created() {
        this.isGirls = this.$route.query.isGirls;

        await this.loadGradesSetup();
        await this.loadRegID();

        await this.loadRates();
        await this.loadDates();
        await this.loadCountries();

        this.loadClasses();
    },
    mounted() {
        window.addEventListener("keyup", this.onKeyPressed);
    },
    methods: {
        onKeyPressed(e) {
            //console.log(e.keyCode);
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get(
                "api/lapidusDayCamp/getGradesSetup",
            );
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        async loadClasses() {
            let classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID,
            );

            classes = classes.filter((c) => {
                return c.regID.trim() == this.regID && c.classType != "Bunk";
            });

            this.classes = classes.filter((c) => c.classType == "Lapidus");
            this.girlsClasses = classes.filter(
                (c) => c.classType == "LapidusGirls",
            );
        },
        async loadRates() {
            const rates = await this.$http.get(
                "api/lapidusDayCamp/getDayCampSetup",
            );

            this.rates = rates.filter((r) => r.udcregid == this.regID);
        },
        async loadDates() {
            const start = new Date(
                this.rates.filter(
                    (f) => f.udcclass == "LU" && f.udcregid == this.regID,
                )[0].udcstarts,
            ).toISOString();
            const end = new Date(
                this.rates.filter(
                    (f) => f.udcclass == "LU" && f.udcregid == this.regID,
                )[0].udcends,
            ).toISOString();

            const dates = await this.$http.get(
                `api/lapidusDayCamp/getHDates?startDate=${start}&endDate=${end}`,
            );

            this.dates = this.setupDates(dates);
        },
        setupDates(dates) {
            return Object.keys(groupBy(dates, "hparsha")).map((week, index) => {
                const weekDays = groupBy(dates, "hparsha")[week];

                return {
                    parshe: week,
                    weekNumber: index,
                    dates: weekDays.map((d) => Date.parse(d.pardate)),
                    sunday: this.getDayOfWeek("Sunday", weekDays),
                    monday: this.getDayOfWeek("Monday", weekDays),
                    tuesday: this.getDayOfWeek("Tuesday", weekDays),
                    wednesday: this.getDayOfWeek("Wednesday", weekDays),
                    thursday: this.getDayOfWeek("Thursday", weekDays),
                    friday: this.getDayOfWeek("Friday", weekDays),
                    saturday: this.getDayOfWeek("Saturday", weekDays),
                };
            });
        },
        getDayOfWeek(day, weekDays) {
            return weekDays.find((w) => w.day == day);
        },
        async loadCardHistory() {
            this.cardHistory = await this.$http.get(
                "api/lapidusDayCamp/getCardHistory?accountID=" +
                    this.account.accountID,
            );
        },
        onSearchAccounts(search, loading) {
            loading(true);

            this.searchAccounts(loading, search);
        },
        async searchAccounts(loading, searchTerm) {
            const request = odata({
                service: getDomain() + "/odata/",
                resources: "accounts",
            }).top(30);

            request._headers[
                "Authorization"
            ] = this.$store.state.authentication.token;

            if (searchTerm) {
                request.filter(`startswith(lastname, '${searchTerm}')`);
            }

            const response = await request.get();

            this.accounts = JSON.parse(response.body).value.map((account) => {
                account.displayName =
                    account.lastName + " " + account.firstName;

                return account;
            });

            loading(false);
        },
        async loadCountries() {
            this.countries = await loadOptions("country");
        },
        onSearchAccountsRowClicked(account) {
            this.searchDialog = false;

            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        onNewAccountCreated(account) {
            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        onNewStudentCreated(student) {
            this.newStudentDialog = false;

            this.students.push(this.mapStudent(student));
        },
        async searchByPhone(value) {
            if (value.length < 10) return;

            const account = await this.$http.get(
                `api/lapidusDayCamp/getAccountByPhoneNumber?phoneNumber=${value}`,
            );

            if (!account) {
                this.$notify({
                    text: "Account Does Not Exist",
                    group: "notification",
                    type: "warning",
                });

                return;
            }

            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        async onSelected(account) {
            if (!account) {
                return this.clearSelection();
            }

            this.accounts = [];

            this.onAccountSelected();
        },
        async onAccountSelected() {
            this.students = [];
            this.bungalow = "";
            this.country = "";
            this.customCountry = "";

            this.loadingAccountInfo = true;

            try {
                const exist = await this.validateExistence();

                if (exist) return;

                await this.loadStudents();
                await this.loadCountryInfo();
                await this.loadPastYearsEnrollmentInfo();

                this.loadingAccountInfo = false;
            } catch (e) {
                this.loadingAccountInfo = false;
            }
        },
        async loadCountryInfo() {
            try {
                const response = await this.$http.get(
                    "api/lapidusDayCamp/GetLapidusAccountCountry?accountID=" +
                        this.account.accountID,
                );

                if (response && response.familyID) {
                    const country = this.countries.find(
                        (c) => c.id == response.countryID,
                    );

                    if (country) {
                        this.country = country.value;
                    } else {
                        this.country = "Other";
                        this.customCountry = response.countryDescription;
                    }

                    this.bungalow = response.bungalow;
                }
            } catch (e) {}
        },
        async loadPastYearsEnrollmentInfo() {
            const url = this.isGirls
                ? `api/lapidusDayCamp/GetDayCampEnrollmentDetailsPerYear?accountID=${
                      this.account.accountID
                  }`
                : `api/lapidusDayCamp/getEnrollmentDetailsPerYear?accountID=${
                      this.account.accountID
                  }`;

            const info = await this.$http.get(url);

            this.pastYearsEnrollmentInfo = info;
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e) {
            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                this.files = files;

                formData.append("upload_file", this.files[0]);

                const response = await this.$http.post(
                    "api/lapidusDayCamp/uploadLunchDocument",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.lunchDocumentUrl = response;

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        bungalowRequired() {
            return this.country == "Satmar - Lapidus" && !this.bungalow;
        },
        async validateExistence() {
            let url =
                "api/lapidusDayCamp/GetLapidusAccount?accountID=" +
                this.account.accountID +
                "&regID=" +
                this.regID;

            if (this.isGirls) {
                url =
                    "api/lapidusDayCamp/GetLapidusDayCampAccount?accountID=" +
                    this.account.accountID +
                    "&regID=" +
                    this.regID;
            }

            const exist = await this.$http.get(url);

            if (!exist) return false;

            if (exist) {
                this.$notify({
                    text: "Account Already Exist",
                    group: "notification",
                    type: "error",
                });

                return true;
            }
        },
        async loadStudents() {
            try {
                let students = await ky.get(
                    this.$Progress,
                    `api/lapidusDayCamp/getStudents?linkId=${
                        this.account.accountLinkID
                    }&pin=${this.account.pinNum}`,
                );

                if (this.isGirls) {
                    students = students.filter((s) => s.class.startsWith("G"));
                } else {
                    students = students.filter((s) => s.class.startsWith("B"));
                }

                this.students = students
                    .filter(this.hasDayCamp)
                    .map(this.mapStudent);
            } catch (e) {}
        },
        hasDayCamp(student) {
            if (!this.gradesSetup.find((g) => g.grade == student.class)) return;

            return this.gradesSetup.find((g) => g.grade == student.class)
                .isCountryAvail;
        },
        mapStudent(student) {
            student.duration = "NONE";
            student.selected = false;
            student.chosenClass = "";
            student.editingAmount = false;
            student.paymentAmount = 0;
            student.lunchDoc = false;

            student.explicitWeeks = {
                week1: false,
                week2: false,
                week3: false,
                week4: false,
                week5: false,
                week6: false,
                week7: false,
                week8: false,
                week9: false,
            };

            student.price = () => this.getRate(student);

            return student;
        },
        getRate(student) {
            const rateCode = this.getRateCode(student);

            if (!rateCode) return 0;

            const rate = this.rates.find((r) => r.udcclass == rateCode);

            switch (student.duration) {
                case "FULL":
                    return rate["udcamtf"];
                case "HALF 1":
                case "HALF 2":
                    return rate["udcamthalf"];
                case "CUSTOM":
                    const weekCount = Object.keys(student.explicitWeeks)
                        .map((key) => student.explicitWeeks[key])
                        .filter(Boolean).length;

                    return Math.min(
                        weekCount * rate["udcamt1w"],
                        rate["udcamtf"],
                    );
                default:
                    return 0;
            }
        },
        getRateCode(student) {
            if (student.class.startsWith("G")) {
                return "G";
            }

            if (!this.country) return;

            if (!student.nonUTA) {
                switch (this.country) {
                    case "Satmar - Lapidus":
                        return "LU";
                    default:
                        if (
                            ["B-KNG", "B-NUR", "B-PRE1A"].includes(
                                student.class,
                            )
                        )
                            return "OU-YOUNG";

                        return "OU-OLD";
                }
            }

            switch (this.country) {
                case "Satmar - Lapidus":
                    return "LO";
                default:
                    if (["B-KNG", "B-NUR", "B-PRE1A"].includes(student.class))
                        return "OO-YOUNG";

                    return "OO-OLD";
            }
        },
        clearSelection() {
            this.phoneSearch = "";
            this.students = [];
        },
        getPaymentAmount() {
            return sum(
                this.students.map((s) => +s.paymentAmount || +s.price()),
            );
        },
        submit() {
            if (
                !this.account ||
                this.students.every((s) => s.duration == "NONE")
            ) {
                this.$notify({
                    text: this.getErrorMessage(),
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (this.country == "Satmar - Lapidus" && !this.bungalow) {
                this.$notify({
                    text: "Please enter bungalow #",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            const validations = [
                this.$refs.country.validate(true),
                this.$refs.studentsList.validate(true),
            ];

            if (this.country == "Other") {
                validations.push(this.$refs.customCountry.validate(true));
            }

            if (!validations.every(Boolean)) return;

            this.openConfirmDialog();
        },
        getErrorMessage() {
            if (!this.account) return "No Account Selected";

            return this.students.length
                ? "Please Chose Duration"
                : "No Students";
        },
        openConfirmDialog() {
            this.confirmDialog = true;
        },
        getDurationDisplay(student) {
            if (student.duration != "CUSTOM") return student.duration;

            const weekCount = Object.keys(student.explicitWeeks)
                .map((key) => student.explicitWeeks[key])
                .filter(Boolean).length;

            return weekCount + " Weeks";
        },
        getApplicationData() {
            const enrollments = this.students
                .filter((s) => s.duration != "NONE")
                .map((student) => ({
                    familyID: this.account.accountID,
                    studentID: student.studentID,
                    regID: this.regID,
                    regType: student.duration,
                    class: student.class,
                    classId: student.chosenClass.classID,
                    chargeCat: this.isGirls ? "LPDC" : "LAPC",
                    chargeCode: this.regID,
                    amount: student.paymentAmount || student.price(),
                    week1: this.hasWeek(student, 1),
                    week2: this.hasWeek(student, 2),
                    week3: this.hasWeek(student, 3),
                    week4: this.hasWeek(student, 4),
                    week5: this.hasWeek(student, 5),
                    week6: this.hasWeek(student, 6),
                    week7: this.hasWeek(student, 7),
                    week8: this.hasWeek(student, 8),
                    week9: this.hasWeek(student, 9),
                    price: student.price(),
                    lunchDoc: student.lunchDoc,
                }));

            const data = {
                user: this.$store.state.authentication.user,
                countryId:
                    this.country != "Other"
                        ? this.countries.find((c) => c.value == this.country).id
                        : "",
                countryDescription:
                    this.country != "Other" ? this.country : this.customCountry,
                note: this.note,
                bungalow: this.bungalow,
                lunchDocument: this.lunchDocument == "hasLunchDocument",
                lunchDocumentUrl: this.lunchDocumentUrl,
                lunchProgramIneligible:
                    this.lunchDocument == "lunchProgramIneligible",
                enrollments: enrollments,
            };

            return data;
        },

        hasWeek(student, week) {
            switch (student.duration) {
                case "FULL":
                    return true;
                case "CUSTOM":
                    const field = "week" + week;

                    return !!student.explicitWeeks[field];
                case "HALF 1":
                    return week >= 1 && week <= 5;
                case "HALF 2":
                    return week >= 5 && week <= 9;
            }
        },
        async confirm(goToNext = false) {
            const applicationData = this.getApplicationData();

            this.processing = true;

            try {
                await ky.post(this.$Progress, "api/lapidusDayCamp/apply", {
                    queryParams: {
                        accountID: this.account.accountID,
                    },
                    data: applicationData,
                });
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;

            if (goToNext) {
                this.account = {};
                this.students = [];

                this.phoneSearch = "";
                this.country = "";
                this.customCountry = "";
                this.note = "";

                this.confirmDialog = false;

                this.$notify({
                    text: "Registration Successful",
                    group: "notification",
                    type: "success",
                });

                return;
            }

            this.$notify({
                text: "Registration Successful",
                group: "notification",
                type: "success",
            });

            this.confirmDialog = false;

            this.$router.push({
                name: "LapidusAccountView",
                params: { id: this.account.accountID, reg_id: this.regID },
                query: {
                    isGirls: this.isGirls,
                },
            });
        },
        closeNewAccountModal() {
            this.newAccountDialog = false;
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        async editAccount() {
            const newAccountPrefill = await this.$http.get(
                "api/lapidusDayCamp/getNewAccount?accountID=" +
                    this.account.accountID,
            );

            this.$refs.newAccount.prefill(newAccountPrefill);

            this.newAccountDialog = true;
        },
    },
};
</script>
<style>
.accounts-search.container {
    padding-top: 0px;
}
.v-btn__content {
    color: unset;
}
.bungalow-required {
    border-bottom: 2px red solid;
}
</style>
